import { render } from "./ReviewKeywordsModal.vue?vue&type=template&id=6c0c03c7&scoped=true"
import script from "./ReviewKeywordsModal.vue?vue&type=script&lang=js"
export * from "./ReviewKeywordsModal.vue?vue&type=script&lang=js"

import "./ReviewKeywordsModal.vue?vue&type=style&index=0&id=6c0c03c7&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0c03c7"]])

export default __exports__